import React from "react"

import type { StakeholderFilter } from "../../../types/types"
import { stakeholderTypes } from "../../../config/application-definitions"
import SelectTags from "../../common/tags/SelectTags"

const statuses = [
    {
        label: "Approved",
        value: true
    },
    {
        label: "Rejected",
        value: false
    }
]

type Props = {
    model: StakeholderFilter,
    activeFilterType: string,
    onFilterTypeChange: (SyntheticEvent<>) => void,
    onEventChange: (SyntheticEvent<>) => void,
    onValueChange: string => void,
    onTopicsSearch: (SyntheticEvent<>) => void,
    onDimensionsSearch: (SyntheticEvent<>) => void
}

const StakeholderFilterForm = ({
    activeFilterType,
    model,
    onFilterTypeChange,
    onEventChange,
    onValueChange,
    onTopicsSearch,
    onDimensionsSearch
}: Props) => (
    <form name="filterform">
        <div className="filter-block">
            <label>Status</label>
            <select
                className="form-control"
                name="approved"
                value={model.approved}
                onChange={onEventChange}
            >
                <option value="">All</option>
                {statuses.map(({ label, value }) => (
                    <option value={value} key={value.toString()}>
                        {label}
                    </option>
                ))}
            </select>
        </div>
        <div className="filter-block">
            <label>Filter by</label>
            <select
                name="filterType"
                className="form-control"
                value={activeFilterType}
                onChange={onFilterTypeChange}
            >
                <option default>Please select</option>
                <option value="insightArea">Insight Area</option>
                <option value="keyIssue">Key Issue</option>
            </select>
        </div>
        {activeFilterType === "insightArea" && (
            <div className="filter-block">
                <label>Insight Area</label>
                <SelectTags
                    name="topic"
                    value={model.topic}
                    multi={false}
                    loadOptions={onTopicsSearch}
                    placeholder="Insight Areas"
                    onChange={onValueChange("topic")}
                />
            </div>
        )}
        {activeFilterType === "keyIssue" && (
            <div className="filter-block">
                <label>Key Issue</label>
                <SelectTags
                    name="dimension"
                    value={model.dimension}
                    multi={false}
                    loadOptions={onDimensionsSearch}
                    placeholder="Key Issues"
                    onChange={onValueChange("dimension")}
                />
            </div>
        )}
        <div className="filter-block">
            <label>Type</label>
            <select
                className="form-control"
                name="type"
                value={model.type}
                onChange={onEventChange}
            >
                <option value="">All</option>
                {stakeholderTypes.map(type => (
                    <option value={type} key={type}>
                        {type}
                    </option>
                ))}
            </select>
        </div>
    </form>
)

export default StakeholderFilterForm
